import type { Component, ComponentListener, EcsSystem, Entity } from '@inter-ikea-core/core';

type OnAddFn<Comp extends Component> = (entity: Entity, newComponent: Comp) => void;

type OnUpdateFn<Comp extends Component> = (entity: Entity, oldComponent: Comp, newComponent: Comp) => void;

type OnRemoveFn<Comp extends Component> = (entity: Entity, oldComponent: Comp) => void;

export class ComponentListenerImpl<TComponent extends Component> implements ComponentListener {
  readonly ownerSystem: EcsSystem | null;
  readonly componentId: number;
  private onComponentAddedRef: OnAddFn<TComponent>;
  private onComponentUpdatedRef: OnUpdateFn<TComponent>;
  private onComponentRemovedRef: OnRemoveFn<TComponent>;

  constructor(
    owner: EcsSystem | null,
    componentId: number,
    onComponentAddedRef: OnAddFn<TComponent>,
    onComponentUpdatedRef: OnUpdateFn<TComponent>,
    onComponentRemovedRef: OnRemoveFn<TComponent>
  ) {
    this.ownerSystem = owner;
    this.componentId = componentId;
    this.onComponentAddedRef = onComponentAddedRef;
    this.onComponentUpdatedRef = onComponentUpdatedRef;
    this.onComponentRemovedRef = onComponentRemovedRef;
  }

  onAdd(entity: Entity, newComponent: TComponent): void {
    this.onComponentAddedRef(entity, newComponent);
  }
  onUpdate(entity: Entity, oldComponent: TComponent, newComponent: TComponent): void {
    this.onComponentUpdatedRef(entity, oldComponent, newComponent);
  }
  onRemove(entity: Entity, oldComponent: TComponent): void {
    this.onComponentRemovedRef(entity, oldComponent);
  }
}
